var React = require('react');

function ExpenseCardIconInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12.5","cy":"12.5","r":"12.5","fill":"#DBDCE0","fillOpacity":"0.5","key":0}),React.createElement("rect",{"x":"6.875","y":"8.3125","width":"11.25","height":"8.125","rx":"2","fill":"black","key":1}),React.createElement("rect",{"x":"6.375","y":"7.8125","width":"12.25","height":"9.125","rx":"2.5","stroke":"#DBDCE0","strokeOpacity":"0.35","key":2}),React.createElement("path",{"d":"M18.4375 10H6.5625V11.25H18.4375V10Z","fill":"#E7E7EA","key":3})]);
}

ExpenseCardIconInline.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = ExpenseCardIconInline;

ExpenseCardIconInline.default = ExpenseCardIconInline;
